<template>
  <draggable
      class="Item_sort"
      tag="ul"
      :list="pages"
      :child="child"
      :group="{ name: 'g1' }"
      item-key="name"
      @sort="changeSort(pages)"
  >
    <template #item="{ element }">
      <li v-if="element.sub_page && element.sub_page.length > 0" :class="child ? 'pa_0 transparent_bg' : ''">
        <div class="has_subclass_acc">
          <div data-toggle="accordion_noslide" :data-target="'#item' + element.id" :class="['onleft_acc_arrow', {'open_acc':openTab == element.id}]" data-class="accordion"></div>
          <span @click="editPage(element)" class="show_page_name">
            <i @click="openAccordian(element.id)">Title: {{element.name}}</i>
            <i @click="openAccordian(element.id)">Menu Name: {{element.menu}}</i>
            <i>
              <router-link :to="{name:'page_edit', params:{id:element.id}}" class="color_success mr_10"> Edit</router-link>
              <a href="javascript:void(0)" class="color_danger" @click="deletePage(element.id)"> Delete</a>
            </i>

          </span>
        </div>
        <nested-draggable
            :pages="element.sub_page"
            :id="'item' + element.id"
            :child="true"
            @editPage="editPage"
            @sort="changeSort(pages)"
            :class="['sub_accordion default_accrodion Item_sort_child', {open:openTab == element.id}]"
        />
      </li>
      <li v-else :class="[{'no_subclass_acc': !child}]" >
        <div class="onleft_acc_arrow" v-if="!child"></div>
        <span @click="editPage(element)" class="show_page_name">
          <i>Title: {{element.name}}</i>
          <i>Menu Name: {{element.menu}}</i>

          <i>
            <router-link :to="{name:'page_edit', params:{id:element.id}}" class="color_success mr_10"> Edit</router-link>
            <a href="javascript:void(0)" class="color_danger" @click="deletePage(element.id)"> Delete</a>
          </i>

        </span>
      </li>
    </template>
  </draggable>
</template>
<script>

import draggable from "vuedraggable"

export default {
  name: "nested-draggable",
  components: {
    draggable,
  },
  data(){
    return {
      openTab: null
    }
  },
  props: {
    pages: {
      required: false,
      type: Array,
    },
    child: {
      required: false,
      type: Boolean,
      default: false
    },
  },
  methods: {
    openAccordian(id){
      if(this.openTab === id){
        this.openTab = null
      } else {
        this.openTab = id;
      }
    },
    editPage(row){
      this.$emit('editPage', row)
    },
    changeSort(categories){
      this.$emit('changeSort', categories)
    },
    deletePage(id){
      this.$emit('deleteItem', id)
    }
  }
};
</script>
